export default {
  props: {
    category: {
      type: String,
      default: ''
    },
    categoriesData: {
      type: Array,
      default: []
    },
    length: {
      type: [String, Number],
      default: 'all'
    }
  },
  computed: {
    categories() {
      if (this.length === 'all') {
        return this.categoriesData;
      } else {
        return this.categoriesData.slice(0, this.length);
      }
    }
  }
};